import { useState } from 'react';
import './GuideHeader.css';

export default function GuideHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="guide-header">
      <div className="guide-header-inner">

        {/* ロゴ */}
        <a
          href="/"
          className="guide-header-brand"
          aria-label="POKER DUEL トップへ"
        >
          <img
            src="/favicon.png"
            alt="デュエル ロゴ"
            className="guide-header-logo"
          />

          <div className="guide-header-brand-text">
            <b>POKER DUEL</b>
            <small>
              ポーカーレンタルスペース デュエル
            </small>
          </div>
        </a>

        {/* PCメニュー */}
        <nav className="guide-header-nav">
          <a href="/#equipment">
            設備
          </a>

          <a href="/#pricing">
            料金
          </a>

          <a href="/#access">
            アクセス
          </a>

          <a href="/#rules">
            お店ルール
          </a>

          <a
            href="/rules"
            className="guide-header-active"
          >
            ポーカーガイド
          </a>
        </nav>

        {/* 予約 */}
        <a
          href="https://upnow.jp/duel"
          target="_blank"
          rel="noopener noreferrer"
          className="guide-header-reserve"
        >
          今すぐ予約
          <span>登録不要</span>
        </a>

        {/* スマホ ハンバーガー */}
        <button
          type="button"
          className={`guide-menu-button ${
            menuOpen ? 'is-open' : ''
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニューを開く"
          aria-expanded={menuOpen}
        >
          <span />
          <span />
          <span />
        </button>

      </div>

      {/* スマホメニュー */}
      <div
        className={`guide-mobile-menu ${
          menuOpen ? 'is-open' : ''
        }`}
      >
        <nav>
          <a
            href="/#equipment"
            onClick={() => setMenuOpen(false)}
          >
            設備
          </a>

          <a
            href="/#pricing"
            onClick={() => setMenuOpen(false)}
          >
            料金
          </a>

          <a
            href="/#access"
            onClick={() => setMenuOpen(false)}
          >
            アクセス
          </a>

          <a
            href="/#rules"
            onClick={() => setMenuOpen(false)}
          >
            お店ルール
          </a>

          <a
            href="/rules"
            onClick={() => setMenuOpen(false)}
          >
            ポーカーガイド
          </a>
        </nav>
      </div>
    </header>
  );
}